/* tslint:disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DmsApiConfiguration, DmsApiConfigurationParams } from './dms-api-configuration';

import { DmsDocumentsClient } from './services/dms-documents-client';
import { DmsSystemClient } from './services/dms-system-client';
import { DmsTagsClient } from './services/dms-tags-client';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DmsDocumentsClient,
    DmsSystemClient,
    DmsTagsClient,
    DmsApiConfiguration
  ],
})
export class DmsApiModule {
  static forRoot(params: DmsApiConfigurationParams): ModuleWithProviders {
    return {
      ngModule: DmsApiModule,
      providers: [
        {
          provide: DmsApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: DmsApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('DmsApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}